import styled from "styled-components";
import { WrapContainer } from "../../components/wrapContainer";

// I dati del team restano vicini al componente per rendere semplice aggiornarli.
const teamMembers = [
  {
    name: "Luca Baroni",
    image: "/team/LUCABARONI.webp",
    description:
      "Classe 1979, ha maturato oltre 20 anni di esperienza nel settore del noleggio a lungo termine, con una conoscenza approfondita sia dei processi interni che della gestione e consulenza al cliente. Nel corso della sua carriera ha sviluppato una solida competenza nella gestione di flotte aziendali e nelle soluzioni di mobilità dedicate a privati e professionisti.",
  },
  {
    name: "Paolo Giuntoli",
    image: "/team/PAOLOGIUNTOLI.webp",
    description:
      "Classe 1970, vanta oltre 30 anni di esperienza nel settore automotive, maturata nel commercio e nella vendita di auto nuove e usate. Oggi mette la sua competenza e la profonda conoscenza del mercato al servizio della mobilità del futuro: il noleggio a lungo termine.",
  },
];

const Section = styled.section`
  max-width: var(--page-max-width);
  width: 100%;
  padding: 4em 0;
`;

const Title = styled.h2`
  margin: 0 0 1.5em;
  text-align: center;
`;

const MembersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 3em;
  max-width: 1000px;
  margin: 0 auto;

  @media screen and (max-width: 760px) {
    grid-template-columns: 1fr;
    gap: 2.5em;
  }
`;

const Member = styled.article`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const Portrait = styled.img`
  width: min(100%, 320px);
  aspect-ratio: 4 / 5;
  object-fit: cover;
  border-radius: 10px;
`;

const Name = styled.h3`
  margin: 1.25em 0 0.6em;
  text-transform: uppercase;
`;

const Description = styled.p`
  max-width: 470px;
  margin: 0;
  line-height: 1.65;
`;

export function Team() {
  return (
    <WrapContainer>
      <Section aria-labelledby="team-title">
        <Title id="team-title">IL NOSTRO TEAM</Title>

        <MembersGrid>
          {teamMembers.map((member) => (
            <Member key={member.name}>
              <Portrait
                src={member.image}
                alt={`Ritratto di ${member.name}`}
                loading="lazy"
              />
              <Name>{member.name}</Name>
              <Description>{member.description}</Description>
            </Member>
          ))}
        </MembersGrid>
      </Section>
    </WrapContainer>
  );
}
